var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fill-height"},[_c('action-tile',{attrs:{"image":"no-lot.svg","icon":_vm.icon,"max-image-width":_vm.maxImageWidth,"title":"lot.create","subtitle":"lot.no-lots","border":true,"disabled":!_vm.canAddLot},on:{"click":_vm.addLot}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }